import {Component, OnInit, Input, SimpleChanges, Output, EventEmitter, AfterViewInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../services/index';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { AppLogComponent } from '../app-log/app-log.component';
import { AppArcComponent } from '../app-arc/app-arc.component';
import { Item } from '../../model/item'
import {ItemService} from '../../services/item.service';
import {TranslateService} from '@ngx-translate/core';
import {MultiSelectModule} from 'primeng/multiselect';
import {RecordDataComponent} from '../record-data/record-data.component';
import {json} from "ng4-validators/src/app/json/validator";
import {appConfig} from "../../app.config";
import {PurchasesShowComponent} from "../../views/pro/purchases/purchases-show/purchases-show.component";
import {JournalsShowComponent} from "../../views/fin/journals/journals-show/journals-show.component";
import {RecieptVouchersShowComponent} from "../../views/fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component";
import {InvoicesShowComponent} from "../../views/pos/invoices/invoices-show/invoices-show.component";
import {ExpenseVouchersShowComponent} from "../../views/fin/expense_vouchers/expense_vouchers-show/expense_vouchers-show.component";
import {ReturninvoicesShowComponent} from "../../views/pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {Http, Headers, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {AppTasksComponent} from '../app-tasks/app-tasks.component';

@Component({
  selector: 'app-list-layout',
  templateUrl: './list-layout.component.html',
  styleUrls: ['./list-layout.component.scss'],
  providers:[ItemService, ConfirmationService , MessageService]
})
export class ListLayoutComponent implements OnInit, AfterViewInit {
  public items: any[];
  public transStatus: any = [];
  public totalRec: number;
  public page: number;
  public per_page: number;
  public sortCol = '';
  public colname = '';
  public creationid = '';
  public sum: any = [];
  public sumval: any = [];

  lang: string;
  item_id: string;
  user_email: string;
  closeResult: string;
  emailform: FormGroup;

  public systemName = '';
  public userid = 0;

  filterdata: any ={};
  filterForm: FormGroup;
  msgs: Message[] = [];

  @Input() refShow;
  @Input() modelName;
  @Output() update_event = new EventEmitter();
  @ViewChild('email') email;

  public columns: any[]=[];
  public selected: any[];
  public allcolumns: any;
  public listcolumns: any[]=[];
  public userRoles: any[]=[];
  public hiddenFields: any[] = [];


  private _newButton: any;
  private _searchButton: any;
  private _printButton: any;
  private _excelButton: any;
  private _emailButton: any;


  constructor(private router: Router,
              private http: Http,
              private route: ActivatedRoute,
              private itemService: ItemService,
              public translate: TranslateService,
              private formBuilder: FormBuilder,
              private sharedservice: SharedService,
              private modalService: NgbModal,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) {

    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setButtons([
      { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
      { label: 'Search', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
      { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
      { label: 'Send By Email', icon: 'fa-share', btnClass: 'btn-primary', btnId: 'emailButton'},
      { label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: 'excelButton' }
    ]);
    this.refShow = this.sharedservice.getItemShow();
    this.modelName = this.sharedservice.getModelName();
    this.itemService.urlString = this.sharedservice.getModelName();
    this.allcolumns = this.sharedservice.getColums();
    this.allcolumns.push({key: "trans_status", title: "trans_status"});
  }

  fieldsControl(screen:string='') {
    if(screen === '') {
      return;
    }
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if(!userdata.fields){
      this.hiddenFields = [];
    } else {
      this.hiddenFields = (userdata.fields.screens[screen])?userdata.fields.screens[screen]:[];
    }

    this.listcolumns = [];
      this.allcolumns.forEach(col=> {
        let object = {label:col.title,value:col};
        if(this.hiddenFields.indexOf(col.key) === -1){
          this.listcolumns.push(object);
        }
      });
    this.columnchange();
  }

  recordData(item) {
    const options: NgbModalOptions = {
      beforeDismiss: () => {
        return true;
      }
    };
    const modalRef = this.modalService.open(RecordDataComponent,options);
    modalRef.componentInstance.refRec = item;
    modalRef.componentInstance.rowId = '';
  }


  ngAfterViewInit() {

  }


  ngOnInit() {
    this.transStatus = [
      {'val':0,'title':'New','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'white', 'border': '1px solid gray', 'color': 'black', 'width':'95px'}},
      {'val':1,'title':'Under Process','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': '#afaf26',  'border': '1px solid black', 'color': 'white', 'width':'95px'}},
      {'val':2,'title':'Done','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'green',  'border': '1px solid black', 'color': 'white', 'width':'95px'}},
      {'val':3,'title':'Decline','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'red',  'border': '1px solid black', 'color': 'white', 'width':'95px'}},
      {},
      {},
      {},
      {},
      {},
      {'val':9,'title':'Not a Process','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'gray',  'border': '1px solid black', 'color': 'dark-gray', 'width':'95px'}}
    ];
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
      this.systemName = userdata.systems[0];
      this.userid = userdata.id;
      this.lang = userdata.lang;
      this.user_email = userdata.email;
    }
    this.emailform = new FormGroup({
      email: new FormControl('', Validators.required),
    });

    this.loadingPage();
  }

  columnchange() {
    let i=1;
    this.listcolumns.forEach(col=> {
      if(i <= 5) {
        this.columns.push(col.value);
      }
      i++;

    });
    this.getAll();
  }

  sumcolum(key: any){
    let idx_u : any;
    idx_u = this.sum.indexOf(key);
    if (idx_u == -1){
      this.sum.push(key);
      localStorage.setItem('summ', JSON.stringify(this.sum));
    }
    if (idx_u >= 0){
      this.sum.splice(idx_u,1);
      //delete this.sum[key];
      localStorage.setItem('summ', JSON.stringify(this.sum));

    }

    //window.alert(this.sum);
    this.getAll();
  }

  loadingPage() {
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setButtons([
      { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
      { label: 'Search', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
      { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
      { label: 'Send By Email', icon: 'fa-share', btnClass: 'btn-skype', btnId: 'emailButton' },
      { label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: 'excelButton' }
    ]);
    this.update_event.emit(null);
    this.refShow = this.sharedservice.getItemShow();
    this.modelName = this.sharedservice.getModelName();
    this.itemService.urlString = this.sharedservice.getModelName();


    this.filterForm = this.formBuilder.group({
      keyword: new FormControl('')
    });

    if(localStorage.getItem('filter')) {
      this.filterdata = JSON.parse(localStorage.getItem('filter'));
    }
    if(localStorage.getItem('summ')) {
      this.sum = JSON.parse(localStorage.getItem('summ'));
    }

    this._newButton = document.getElementById('newButton');
    this._searchButton = document.getElementById('searchButton');
    this._printButton = document.getElementById('printButton');
    this._excelButton = document.getElementById('excelButton');
    this._emailButton = document.getElementById('emailButton');
    if (this.modelName === '') {
      return;
    }
    this.fieldsControl(this.systemName+'.'+this.modelName);

    if(!this._newButton || !this._searchButton) {
      return;
    }

    this._newButton.onclick = ((e: any) => {
      e.preventDefault();
      this.router.navigate(['/'+this.modelName]);
    });

    this._printButton.onclick = ((e:any)=> {
      e.preventDefault();
      this.print();
    });

    this._emailButton.onclick = ((e:any)=> {
      e.preventDefault();
      this.sendEmail(this.email);
    });

    this._excelButton.onclick = ((e:any)=> {
      e.preventDefault();
      this.excel();
    });

    this._searchButton.onclick = ((e: any) => {
      e.preventDefault();
      this.router.navigate(['/'+this.modelName+'/search']);
    });

  }

  openpopup(doc,type) {
    if(type === 0) {
      const modalRef = this.modalService.open(JournalsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 2) {
      const modalRef = this.modalService.open(PurchasesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 3){
      //const modalRef = this.modalService.open(Retu);
    } else if(type === 4){
      const modalRef = this.modalService.open(InvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 5){
      const modalRef = this.modalService.open(ReturninvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 6){
      const modalRef = this.modalService.open(RecieptVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 7){
      const modalRef = this.modalService.open(ExpenseVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    }

  }

  docPrint(item:any) {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    const tokenapi = userdata.api_token;
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    window.open(appConfig.apiUrl + this.modelName + '/print/'+item.id+'?token='+ tokenapi )
  }

  open(content, id) {
    this.item_id = id;
    this.modalService.open(content).result.then((result) => {
      console.log(result);
    }, (reason) => {
      this.closeResult = 'Dismissed';
    });
  }

  sendByEmail(modal){
    if (this.emailform.valid){
      modal('close modal');
      if(this.item_id){
        const id = this.item_id;
        this.item_id = null;
        return this.http.post(this.modelName + '/send/' + id,{'email':this.emailform.controls['email'].value, 'lang':this.lang}).subscribe(res => {console.log(res , "mail sended for item");});
      }else{
        this.itemService.printlist(this.sortCol,this.columns,this.modelName,"email",JSON.stringify(this.sum),this.emailform.controls['email'].value ).subscribe(
          res => {
            console.log(res , "mail sended for list");
          }
          );
      }
      this.emailform.patchValue({
        email: '',
      });
    }else
      this.validateAllFormFields(this.emailform);
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  print() {
    this.itemService.printlist(this.sortCol,this.columns,this.modelName,"pdf",JSON.stringify(this.sum));
  }

  sendEmail(content) {
    this.modalService.open(content).result.then((result) => {
      console.log(result);
    }, (reason) => {
      this.closeResult = 'Dismissed';
    });
  }

  excel() {
    this.confirmationService.confirm({
      header: this.translate.instant('Print Excel Sheet'),
      message: this.translate.instant('Are_you_Excel?'),
      icon: 'fa fa-file-excel-o',
      accept: () => {
        this.itemService.printlist(this.sortCol,this.columns,this.modelName,'excel',JSON.stringify(this.sum));
      },
      reject: () => {
        this.itemService.printlist(this.sortCol,this.sharedservice.getColums(),this.modelName,'excel',JSON.stringify(this.sum));
      }
    });
  }

  changecolname(colName:string) {
    this.colname = colName;
    let filter: any;
    if(localStorage.getItem('filter')) {
      filter = JSON.parse(localStorage.getItem('filter'));
      let keyval = filter[this.colname];
      this.filterForm.patchValue({keyword: keyval});
    }
  }

  loadPage(page: number) {
    if (page !== this.page) {
      this.page = page;
      this.getAll();
    }
  }


  sortPage(sortCol: string) {
    if (sortCol === this.sortCol) {
      sortCol = '-' + sortCol;
    } else {
      this.page = 1;
    }
    this.sortCol = sortCol;
    this.getAll();
  }

  getAll() {
    this.itemService.getAll(this.page, this.sortCol , JSON.stringify(this.sum)).subscribe(
      items => {
        this.items = items.dataarr.data;
        this.sumval = items.summtion;
        this.totalRec = items.dataarr.total;
        this.page = items.dataarr.current_page;
        this.per_page = items.dataarr.per_page;
      },
      err => {
        console.log(err);
      }
    );
  }

  redirectNewPage() {
    this.router.navigate(['/'+this.modelName]);
  }

  editPage(item: any) {
    if(this.modelName === 'years') {
      item.id = item.year;
    }

    if (item) {
      this.router.navigate(['/'+this.modelName+'/edit', item.id]);
    }
  }

  showPage(item: any) {
    if(this.modelName === 'years') {
      item.id = item.year;
    }
    if (item) {
      this.router.navigate(['/'+this.modelName+'/show', item.id]);
    }
  }

  showDelPage(item: any) {
    if(this.modelName === 'years') {
      item.id = item.year;
    }
    if (item) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          this.getAll();
          return true;
        }
      };
      const modalRef = this.modalService.open(this.refShow,options);
      modalRef.componentInstance.delId = item.id;

    }
  }

  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.rowId = row_id;
    }
  }

  showTasks(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppTasksComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.rowId = row_id;
    }
  }

  showattachement(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppArcComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }



  deleteItem(item: any) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Delete'),
      message: this.translate.instant('Are you sure of delete ?'),
      icon: 'fa fa-trash',
      accept: () => {
        if (item) {
          if(this.modelName === 'years') {
            item.id = item.year;
          }
          this.itemService.delete(item.id).subscribe(
            res => {
              this.msgs = [];
              if(res.result) {
                this.msgs.push({severity: 'success', summary: '', detail: this.translate.instant(res.message)});
                setTimeout(()=> {
                  this.getAll();
                  this.router.navigate(['/'+this.modelName+'/list']);
                },1000);
              } else {
                this.msgs.push({severity: 'error', summary: '', detail: this.translate.instant(res.message)});
                // setTimeout(()=> {
                //   this.getAll();
                //   this.router.navigate(['/'+this.modelName+'/list']);
                // },3000);
              }

            }
          );
        }
          window.scroll(0,0);

      }
    });
  }

  onSubmit() {
    const keyword: string = this.filterForm.controls['keyword'].value;
    if(localStorage.getItem('filter')) {
      this.filterdata = JSON.parse(localStorage.getItem('filter'));
    } else {
      this.filterdata = {};
    }
    this.filterdata[this.colname]  = keyword;
    localStorage.setItem('filter', JSON.stringify(this.filterdata));
    this.page = 0;
    this.getAll();
  }

  removeFilter(colname: string) {
    if(localStorage.getItem('filter')) {
      this.filterdata = JSON.parse(localStorage.getItem('filter'));
    } else {
      this.filterdata = {};
    }
    delete this.filterdata[colname];
    localStorage.setItem('filter', JSON.stringify(this.filterdata));
    this.getAll();
  }

  permissionAllow(button:string):boolean {

    let role:string = '';
    switch(button) {
      case 'newButton': {
        role = 'create';
        break;
      }
      case 'saveButton': {
        role = 'update';
        break;
      }
      case 'deleteButton': {
        role = 'delete';
        break;
      }
      case 'searchButton': {
        role = 'search';
        break;
      }
      case 'excelButton': {
        role = 'excel';
        break;
      }
      case 'printButton': {
        role = 'print';
        break;
      }
      case 'emailButton': {
        role = 'print';
        break;
      }
      case 'historyButton': {
        role = 'history';
        break;
      }
      case 'restoreButton': {
        role = 'restore';
        break;
      }
      case 'attachmentsButton': {
        role = 'attachments';
        break;
      }
      case 'rowinfo': {
        role = 'rowinfo';
        break;
      }

      default: {
        role = '';
        break;
      }
    }
    let Osystem = 'setting';
    if(localStorage.getItem('OpenSystem')) {
      Osystem = localStorage.getItem('OpenSystem');
    }

    if(this.modelName == 'itemsGroups' ){
       this.modelName = "items_groups";
    }

    if(this.userRoles.indexOf(Osystem+'.'+this.modelName+'.'+role) >= 0 || this.userRoles.indexOf('setting.'+this.modelName+'.'+role) >= 0) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/list-layout/list-layout.component.ts